import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { NumpadModule } from 'packages/sports/web/app/src/numpad/numpad.module';

import BetslipBaseModule from '../../base/betslip-base.module';
import { DigitalAccaBoostModule } from '../acca-boost/digital-acca-boost.module';
import BetslipDigitalBetGenerationModule from '../bet-generation/betslip-digital-bet-generation.module';
import BetslipDigitalBetPlacementModule from '../betplacement/betslip-digital-betplacement.module';
import { PlaceButtonErrorStateService } from '../betplacement/services/place-button/place-button-error-state.service';
import { QuickDepositModule } from '../quick-deposit/quick-deposit.module';
import { DigitalRewardTokensModule } from '../reward-tokens/digital-reward-tokens.module';
import BetslipDigitalStakeLimitModule from '../stake-limit/betslip-digital-stake-limit.module';
import BetslipDigitalStakeModule from '../stake/betslip-digital-stake.module';
import BetslipDigitalTaxationModule from '../taxation/betslip-digital-taxation.module';
import BetslipDigitalValidationModule from '../validation/betslip-digital-validation.module';
import LinearContainerPossibleWinningsComponent from './components/digital/linear/linear-container-possible-winnings.component';
import LinearContainerSummaryComponent from './components/digital/linear/linear-container-summary.component';
import LinearContainerTotalOddsComponent from './components/digital/linear/linear-container-total-odds.component';
import SummaryComponent from './components/digital/summary.component';
import { TokenSummaryContainerComponent } from './components/digital/token-summary-container.component';
import { TokenSummaryComponent } from './components/digital/token-summary.component';
import BetslipSummaryBuilder from './services/betslip-summary-builder.service';
import { BetslipSummaryService } from './services/betslip-summary.service';

@NgModule({
    imports: [
        CommonModule,
        BetslipBaseModule,
        BetslipDigitalTaxationModule,
        BetslipDigitalBetGenerationModule,
        BetslipDigitalBetPlacementModule,
        BetslipDigitalStakeModule,
        NumpadModule,
        DigitalRewardTokensModule,
        BetslipDigitalStakeLimitModule,
        DigitalAccaBoostModule,
        QuickDepositModule,
        BetslipDigitalValidationModule,
        AutomationModule,
    ],
    providers: [BetslipSummaryBuilder, BetslipSummaryService, PlaceButtonErrorStateService],
    declarations: [
        SummaryComponent,
        TokenSummaryComponent,
        TokenSummaryContainerComponent,
        LinearContainerPossibleWinningsComponent,
        LinearContainerSummaryComponent,
        LinearContainerTotalOddsComponent,
    ],
    exports: [
        SummaryComponent,
        TokenSummaryContainerComponent,
        LinearContainerSummaryComponent,
        LinearContainerPossibleWinningsComponent,
        LinearContainerTotalOddsComponent,
    ],
})
export default class BetslipDigitalSummaryModule {}
